import {
  GET_FITBIT_DATA,
  GET_FITBIT_DATA_SUCCESS,
  GET_FITBIT_DATA_ERROR,
  SYNC_FITBIT_DATA,
  SYNC_FITBIT_DATA_SUCCESS,
  SYNC_FITBIT_DATA_ERROR,
  GET_FITBIT_DATA_RANGE,
  GET_FITBIT_DATA_RANGE_SUCCESS,
  GET_FITBIT_DATA_RANGE_ERROR,
  GET_LATEST_FITBIT_DATA,
  GET_LATEST_FITBIT_DATA_SUCCESS,
  GET_LATEST_FITBIT_DATA_ERROR,
  SET_WEBSOCKET_CONNECTED,
  UPDATE_FITBIT_DATA_FROM_WEBSOCKET,
  CLEAR_FITBIT_ERROR,
  RESET_FITBIT,
} from './constants';

const initialState = {
  todayData: null,
  rangeData: [],
  latestData: [],
  loading: false,
  syncing: false,
  error: null,
  wsConnected: false,
};

function fitbit(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case GET_FITBIT_DATA:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_FITBIT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        todayData: payload.data || payload,
        error: null,
      };

    case GET_FITBIT_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case SYNC_FITBIT_DATA:
      return {
        ...state,
        syncing: true,
        error: null,
      };

    case SYNC_FITBIT_DATA_SUCCESS:
      return {
        ...state,
        syncing: false,
        error: null,
      };

    case SYNC_FITBIT_DATA_ERROR:
      return {
        ...state,
        syncing: false,
        error: payload,
      };

    case GET_FITBIT_DATA_RANGE:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_FITBIT_DATA_RANGE_SUCCESS:
      return {
        ...state,
        loading: false,
        rangeData: payload.data || payload,
        error: null,
      };

    case GET_FITBIT_DATA_RANGE_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_LATEST_FITBIT_DATA:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case GET_LATEST_FITBIT_DATA_SUCCESS:
      return {
        ...state,
        loading: false,
        latestData: payload.data || payload,
        error: null,
      };

    case GET_LATEST_FITBIT_DATA_ERROR:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case SET_WEBSOCKET_CONNECTED:
      return {
        ...state,
        wsConnected: payload,
      };

    case UPDATE_FITBIT_DATA_FROM_WEBSOCKET:
      // Update today's data if the date matches (handle partial/null summary)
      if (state.todayData && state.todayData.date === payload?.date && payload?.summary) {
        return {
          ...state,
          todayData: {
            ...state.todayData,
            summary: { ...state.todayData.summary, ...payload.summary },
            lastSynced: payload.timestamp,
          },
        };
      }
      return state;

    case CLEAR_FITBIT_ERROR:
      return {
        ...state,
        error: null,
      };

    case RESET_FITBIT:
      return initialState;

    default:
      return state;
  }
}

export default fitbit;
